import { useInfiniteQuery } from '@tanstack/react-query'

import { marketShopAPI } from '@/api/new-api'
import { MarketShopProductModel } from '@/models'

export interface GetMarketShopProductsRequest {
  limit: number
  search?: string
  categoryId?: Array<number>
}

export interface GetMarketShopProductsResponse {
  count: number
  products: Array<MarketShopProductModel>
}

export const getMarketShopProductsQueryKey = (data: GetMarketShopProductsRequest) => [
  'useGetMarketShopProducts',
  data,
]

export const getMarketShopProducts = async (
  data: GetMarketShopProductsRequest & { skip: number },
  signal?: AbortSignal,
) => {
  const response = await marketShopAPI.get<GetMarketShopProductsResponse>('/market-shop/products', {
    params: data,
    signal,
  })
  return response.data
}

export const useGetMarketShopProducts = (data: GetMarketShopProductsRequest) => {
  return useInfiniteQuery({
    getNextPageParam: (
      lastPage: GetMarketShopProductsResponse,
      __allPages: GetMarketShopProductsResponse[],
      lastPageParam,
      __allPageParams,
    ) => {
      const newPageParam = lastPageParam + data.limit
      if (newPageParam >= lastPage?.count) return undefined
      return newPageParam
    },
    initialPageParam: 0,
    queryFn: ({ pageParam, signal }) => {
      return getMarketShopProducts({ ...data, skip: pageParam }, signal)
    },
    queryKey: getMarketShopProductsQueryKey(data),
  })
}
